/*-------------  SLIDE 2 animation  -------------*/

function slide21_anima() {
  var homepage = '';
  var cont = '';
	var bmcont = '';

	 $(".slide1").html('');
   $("#help").fadeOut(1000);

		bmcont = '<div id="movePrev"></div><div id="sl21_cnt" class="s21_cnt"></div><div id="sl21_foo" class="menu_bott"></div>';
    $("#slide21").html(bmcont);

		homepage = '<div id="moveHeadPrev"><span class="head-icon"></span><h1>'+jsondata["sl21_head"]+'</h1></div>';
		$("#movePrev").html(homepage);

    $('#slide21').fadeIn(1000);

    returnHome('#movePrev','.slide1','baner-slide-2');

    bmcont = jsondata["sl21_txt"];
    bmcont += '<div id="animate21">';
		pocet = jsondata["sl21_point"].length + 1;
		for (i=1; i<pocet; i++) {

      point = "<div class='circle_pos' id='circle_pos_"+i+"' data-clicked='"+i+"'>";
			point += "<div class='circle_leash' id='circle_leash_"+i+"'></div>";
			point += "<div class='circle_label' id='circle_label_"+i+"'>"+jsondata["sl21_point"][i-1]+"</div>";
			point += "<div class='circle_bg'></div>";
			point += "<div class='circle_anim pulsateME'></div>";
			point += "<div class='circle' id='circle_"+i+"' data-clicked='"+i+"'><span class='circle_number'>"+i+"</span></div>";
			point += "<div class='circle_over' id='circle_over_"+i+"' data-clicked='"+i+"'></div>";
			point += "</div>";

	 	bmcont += point;
		}
    pocet = jsondata["sl21_point2"].length + 1;
    for (i=1; i<pocet; i++) {
      bmcont += "<div class='circle_label' id='circle_label2_"+i+"'>"+jsondata["sl21_point2"][i-1]+"</div>";
    }
		bmcont += '</div>';
    bmcont += '<div id="kapka"></div>';

    bslide = '<div id="detailSlide21"><h1>Úpravna vody<\/h1>';
    pocet = jsondata["sl21_steps"].length + 1;
    for (i=1; i<pocet; i++) {
      bslide += "<div id='slide_label21_"+i+"' style='display:none' class='slide_label_box'>"+jsondata["sl21_steps"][i-1]+"<div class=\"pointGPS pointGPS"+i+"\"><div class=\"gps_point\"></div><div class=\"gps_ring\"></div></div></div>";
    }
    bslide += '<div class=\"slide_close\"></div></div>';
    bmcont += bslide;

    $("#sl21_cnt").html(bmcont);

    bmcont = '<div class="pozadi-grey">';
    pocet = jsondata["sl21_banner"].length;
    for (i=0; i<pocet; i++) {
      bmcont += jsondata["sl21_banner"][i];
    }
    bmcont += '</div>';

    $("#banner_box").html(bmcont);

    $(".circle_pos").on("click", function(){
      $('#detailSlide21').fadeIn(1000);
  		var id = $(this).attr("id");
      switch (id) {
			case "circle_pos_1":
        $('#slide_label21_1').fadeIn(1000);
			break;
			case "circle_pos_2":
        $('#slide_label21_2').fadeIn(1000);
			break;
			case "circle_pos_3":
        $('#slide_label21_3').fadeIn(1000);
			break;
			case "circle_pos_4":
				$('#slide_label21_4').fadeIn(1000);
			break;
      case "circle_pos_5":
				$('#slide_label21_5').fadeIn(1000);
			break;
      case "circle_pos_6":
				$('#slide_label21_6').fadeIn(1000);
			break;
      case "circle_pos_7":
				$('#slide_label21_7').fadeIn(1000);
			break;
		  };
    });

    $(".moveSlideNext").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s21_1_uprava_n":
        $('.slide_label_box').fadeOut(100);
        $('#slide_label21_2').fadeIn(500);
			break;
			case "s21_2_uprava_n":
        $('.slide_label_box').fadeOut(100);
        $('#slide_label21_3').fadeIn(500);
			break;
			case "s21_3_uprava_n":
        $('.slide_label_box').fadeOut(100);
        $('#slide_label21_4').fadeIn(500);
			break;
			case "s21_4_uprava_n":
        $('.slide_label_box').fadeOut(100);
				$('#slide_label21_5').fadeIn(500);
			break;
      case "s21_5_uprava_n":
        $('.slide_label_box').fadeOut(100);
				$('#slide_label21_6').fadeIn(500);
			break;
      case "s21_6_uprava_n":
        $('.slide_label_box').fadeOut(100);
				$('#slide_label21_7').fadeIn(500);
			break;
		  };
    });

    $(".moveSlidePrev").on("click", function(){
  		var id = $(this).attr("id");
      switch (id) {
			case "s21_2_uprava_p":
        $('.slide_label_box').fadeOut(100);
        $('#slide_label21_1').fadeIn(500);
			break;
			case "s21_3_uprava_p":
        $('.slide_label_box').fadeOut(100);
        $('#slide_label21_2').fadeIn(500);
			break;
			case "s21_4_uprava_p":
        $('.slide_label_box').fadeOut(100);
        $('#slide_label21_3').fadeIn(500);
			break;
			case "s21_5_uprava_p":
        $('.slide_label_box').fadeOut(100);
				$('#slide_label21_4').fadeIn(500);
			break;
      case "s21_6_uprava_p":
        $('.slide_label_box').fadeOut(100);
				$('#slide_label21_5').fadeIn(500);
			break;
      case "s21_7_uprava_p":
        $('.slide_label_box').fadeOut(100);
				$('#slide_label21_6').fadeIn(500);
			break;
		  };
    });

    $(".slide_close").on("click", function(){
      $('.slide_label_box').fadeOut(1000);
      $('#detailSlide21').fadeOut(1000);
    });

    $("#kapka").on("click", function(){
  		var id = $(this).attr("id");
        var bannerBox2 = document.getElementById("sl21_banner2");
        TweenMax.to(bannerBox2, 1, {x:0, y:816,  ease:Quint.easeOut});
        TweenMax.to(bannerBox2, 0.5, {autoAlpha:1});
        var bannerBox1 = document.getElementById("sl21_banner3");
        TweenMax.to(bannerBox1, 1, {x:0, y:-387,  ease:Quint.easeOut});
        TweenMax.to(bannerBox1, 0.5, {autoAlpha:1});
        $("#kapka").css("display","none");
        $("#banner_box").css( "z-index", "10" );
        $(".pozadi-grey").css( "z-index", "3" );
    });

    $(".banner_close").on("click", function(){
      var bannerBox2 = document.getElementById("sl21_banner2");
      TweenMax.to(bannerBox2, 1, {x:0, y:-816,  ease:Quint.easeOut});
      TweenMax.to(bannerBox2, 0.5, {autoAlpha:1});
      var bannerBox1 = document.getElementById("sl21_banner3");
      TweenMax.to(bannerBox1, 1, {x:0, y:387,  ease:Quint.easeOut});
      TweenMax.to(bannerBox1, 0.5, {autoAlpha:1});
      $(".pozadi-grey").css( "z-index", "1" );
      $("#banner_box").css( "z-index", "1" );
      $("#kapka").css("display","block");
    });
}
